import { MAX_ATTRIBUTION } from '../../lib/sanitize'

/**
 * Who said a pull quote, written in place under it like an image's caption
 * (Niki, 10/6): a quiet centred line, "— Who said it?" until it's filled.
 * The field sizes to its words (a hidden twin in the same grid cell), so the
 * dash sits right before the name as the reader shows it. One line, so Enter
 * leaves the field. Saved cleaned (lib/sanitize.ts cleanAttribution).
 */
export function QuoteAttributionField({
  value,
  readOnly = false,
  onChange,
}: {
  value: string
  /** Narration sync: shown, not editable. */
  readOnly?: boolean
  onChange: (attribution: string) => void
}) {
  const placeholder = 'Who said it?'
  return (
    <div className="group/said -mt-7 mb-10 flex items-baseline justify-center gap-1.5 px-2 font-sans text-[13.5px] font-medium text-foreground/70">
      <span aria-hidden className={value ? '' : 'text-muted-foreground/50 transition-colors group-focus-within/said:text-muted-foreground'}>
        —
      </span>
      <span className="inline-grid min-w-0 max-w-full">
        <span aria-hidden className="invisible col-start-1 row-start-1 overflow-hidden whitespace-pre">
          {value || placeholder}
        </span>
        <input
          type="text"
          value={value}
          readOnly={readOnly}
          maxLength={MAX_ATTRIBUTION}
          onChange={(e) => onChange(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => {
            e.stopPropagation()
            if (e.key === 'Enter' || e.key === 'Escape') {
              e.preventDefault()
              e.currentTarget.blur()
            }
          }}
          placeholder={placeholder}
          aria-label="Who said it"
          spellCheck
          className="col-start-1 row-start-1 w-full min-w-0 bg-transparent p-0 text-inherit outline-none placeholder:text-muted-foreground/50 focus:placeholder:text-muted-foreground"
        />
      </span>
    </div>
  )
}
